import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './ProductCard.css';

export default function ProductCard({ product }) {
    const { addToCart, loading } = useCart();

    const image = product.images.edges[0]?.node ?? null;
    const price = parseFloat(product.priceRange.minVariantPrice.amount);
    const currency = product.priceRange.minVariantPrice.currencyCode;
    const firstVariantId = product.variants.edges[0]?.node.id ?? null;
    const available = product.variants.edges[0]?.node.availableForSale ?? false;

    const formatPrice = (amount, cur) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: cur }).format(amount);

    const handleQuickAdd = (e) => {
        e.preventDefault();
        if (firstVariantId && available) {
            addToCart(firstVariantId, 1);
        }
    };

    return (
        <Link to={`/product/${product.handle}`} className="product-card">
            <div className="product-card-img-wrap">
                {image ? (
                    <img src={image.url} alt={image.altText || product.title} className="product-card-img" />
                ) : (
                    <div className="product-card-no-img" />
                )}
                {available ? (
                    <button
                        className="product-card-quickadd"
                        onClick={handleQuickAdd}
                        disabled={loading}
                        aria-label={`${product.title} in den Warenkorb`}>
                        + In den Warenkorb
                    </button>
                ) : (
                    <span className="product-card-soldout">Ausverkauft</span>
                )}
            </div>
            <div className="product-card-info">
                <p className="product-card-title">{product.title}</p>
                <p className="product-card-price">{formatPrice(price, currency)}</p>
            </div>
        </Link>
    );
}
